import './dialogs.css';

import React, { useEffect } from 'react';
import { DialogProperties } from './DialogProperties';
import { DialogSelectItem } from './components/DialogSelectItem';
import { DialogSearch } from './components/DialogSearch';
import { DialogConfirm } from './components/DialogConfirm';
import { DialogDefault } from './components/DialogDefault';
import { DialogPilotagePicker } from './components/DialogPilotagePicker';

export const Dialog = ({
    children,
    properties = { ...DialogProperties }
}) => {

    useEffect(() => {
        const elem = document.querySelector("body");
        elem.classList.add("overflow-hidden");

        return (() => {
            const elem = document.querySelector("body");
            elem.classList.remove("overflow-hidden");
        });
    }, []);

    return (
        (() => {
            switch (properties.mode) {
                case "search":
                    return (
                        <DialogSearch properties={properties}>{children}</DialogSearch>
                    )
                case "select":
                    return (
                        <DialogSelectItem properties={properties}/>
                    )
                case "confirmation":
                    return (
                        <DialogConfirm properties={properties}>{children}</DialogConfirm>
                    )
                case "pilotage-picker":
                    return (<DialogPilotagePicker properties={properties} />);
                default:
                    return (
                        <DialogDefault properties={properties}>
                            {/*Prevent focus on first child input element*/}
                            <input style={{ display: "none" }} />
                            {children}
                        </DialogDefault>
                    )
            }
        })()
    )
}
